module.exports = __webpack_public_path__ + "22b321802f2800a5d676a6dbb33a6550.otf";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Khosrau/Khosrau.otf
// module id = 1WuD
// module chunks = 0